<template>
  <div class="app has-header">
    <div class="header main">
      <div class="align-left">
        <dateselectionheader :label="monthDisplay" @PrevDate="PreviousDate" @NextDate="NextDate"
                             @CalendarOpen="toggleDatePicker" @SetToday="SetDateToCurrentDay"/>
      </div>
      <div class="align-middle">
        <headerbuttonstack :state="headerButtons"/>
      </div>
      <div class="align-right">
        <headerbuttonstack :state="sideButtons"/>
      </div>
    </div>


    <div class="tablecontainer scrollbar-container">
      <div v-if="!loading">
        <datatablesimple :state="dataTableSimpleState"></datatablesimple>
      </div>
    </div>
    <div v-if="loading" class="loading-md bg">
      <i class="fas fa-spinner"></i>
      <div v-if="!$helpers.isEmpty(loadingText)" class="loading-text">
        {{ loadingText }}
      </div>
    </div>

  </div>
</template>

<script>
import datatablesimple from '../uicomponents/datatablesimple.vue';
import {mapState, mapGetters} from 'vuex';

export default {
  name: 'fixedcostoverview',
  components: {
    datatablesimple
  },
  data() {
    return {
      loadingText: this.$t('workBalance.averages.loading'),
      employeeMap: {},
      dateSelectionStart: this.$helpers.getCurrentMonthMomentTZ().hours(0).minutes(0),
      timeFrameStart: this.$helpers.getMomentTZ().hours(0).minutes(0),
      currentYear: this.$helpers.getCurrentMonthMomentTZ().year(),
      currentMonth: this.$helpers.getCurrentMonthMomentTZ().month(),
      currentDate: 1,
      periodMap: {
        1: {id: 1, label: this.$t('indicator.crew.daily')},
        2: {id: 2, label: this.$t('indicator.crew.monthly')},
      },
  
      loading: false,

      
    }
  },
  created: function () {
    this.$helpers.GetStoreSettings();
    if (this.rosterFromTo != null) {
      let startDate = this.$helpers.getMomentFromValuesTZ(this.rosterFromTo.year, this.rosterFromTo.month, 1);
      this.setDateSelection(startDate);
    } else {
      this.setDateSelection(this.$helpers.getCurrentMonthMomentTZ());
    }
    this.refresh(true);
  },
  computed: {
    ...mapGetters(['storeId', 'uiDataMap', 'permissions','storeSettings', 'rosterFromTo', 'isSuperUser', 'fixedCostMap']),
    monthDisplay: function () {
      if (this.timeFrameStart != null) {
        return this.timeFrameStart.format('MMM YYYY');
      } else {
        return '-';
      }
    },
    employeeLevelMap() {
      let map = {};
      this.uiDataMap.employeeLevels.forEach(level => {
        let item = {label: level.label_de, value: level.id};
        map[level.id] = item;
      })
      return map;
    },
    headerButtons() {
      let view = this;
      let state = {
        buttons: [

          {
            type: "block",
            icon: "fa-sync-alt",
            click: () => {
              view.refresh(true)
            },
            tooltip: this.$t('global.general.refreshData')
          },
          
        ],
        showListIconAlways: true
      };
      state.buttons.push({type: "block green border-r",icon: "fa-layer-plus",click: ($event) => {view.OpenNewFixedCostPopup($event);},
                          tooltip: this.$t('indicator.crew.createNewFixCosts'),
                          helperText: this.$t('indicator.crew.fixCostHelp'),
                          externalUrl:"https://meindienstplan.atlassian.net/servicedesk/customer/kb/view/2797600769"
                        });
      
            
      state.helperLinks = [
        {
          title:  this.$t('store.structure.getSupport'),
          helperText:  this.$t('store.structure.getSupportHelp'),
          externalUrl: "https://meindienstplan.atlassian.net/servicedesk/customer/portal/1/group/2/create/15",
          externalLabel:  this.$t('store.structure.getSupportLabel'),
          cancelLabel: this.$t('global.ui.close')
        }
      ];
      return state;
    },
    sideButtons() {
      let view = this;

      let state = {
        buttons: [
          
        ]
      };
      state.buttons.push({
          type: "block border-r",
          icon: "fa-print",
          tooltip: this.$t('global.ui.reportsExports'),
          click: ($event) => {view.OpenMenuDetails($event, this.reportMenuState)}
      });

      return state;
    },
    reportMenuState() {
      let view = this;
      let state = {
          componentref: 'burgermenustate',
          groups: [],
          items: []
      };

      let reportGroup = {
          label: this.$t('indicator.crew.pdfReport'),
          items: [
              {
                closeOnClick: true,
                classes: "export-save",
                type: "block green",
                disabled: false,
                icon: "fa-file-pdf",
                click: () => { view.exportFixedCostPDF(); },
                show:  true,
                tooltip: this.$t('indicator.crew.fixCostPdf'),
                text: this.$t('indicator.crew.fixCostPdf'),
                helperText: ''
              },
                       

          ]
      }

      state.groups.push(reportGroup);

                
      return state;
    },
   
    dataTableSimpleState() {
      let view = this;

      //let secondSkills = view.skillsDropdownOptions.filter(item => item.toggled).map(item => item.id);
      

      let data = Object.values(this.fixedCostMap).sort((a, b) => {
        return a.name.localeCompare(b.name);
      });


      let state = {};

      let columns = {};
      columns.name = this.$t('pages.employeeData.name');
      columns.from = this.$t('global.general.from');
      columns.to = this.$t('global.general.to');
      columns.period = this.$t('indicator.crew.period');
      columns.amount = this.$t('indicator.main.amount');
      columns.crewlabor = this.$t('indicator.crew.crewLabor');
      columns.actions = " ";
      
      

      state = this.$helpers.GetDataTableStateFromKeyLabelObject(columns, data);

      

      state.headerMap.name.stylesEntrySum = {color: 'black'}
      state.headerMap.name.sort = true;
      state.headerMap.name.componentStateBuilders = [(data, entry) => {
        return {
          componentType: 'labelc',
          state: {
            text: data.name,
          },
          styleLabel: {
            display: 'flex', alignItems: 'center', justifyContent: 'center', background: '', height: 'calc(100% - 10px)'
          },
        }

      }];
      

      state.headerMap.from.stylesEntrySum = {color: 'black'}
      state.headerMap.from.sort = false;
      state.headerMap.from.componentStateBuilders = [(data, entry) => {
        return {
          componentType: 'labelc',
          state: {
            text: data.from != null ? view.$helpers.getMomentFromStringTZ(data.from).format("DD.MM.YYYY") : '-',
          },
          styleLabel: {
            display: 'flex', alignItems: 'center', justifyContent: 'center', background: '', height: 'calc(100% - 10px)'
          },
        }

      }];

      state.headerMap.to.stylesEntrySum = {color: 'black'}
      state.headerMap.to.sort = false;
      state.headerMap.to.componentStateBuilders = [(data, entry) => {
        return {
          componentType: 'labelc',
          state: {
            text: data.to != null ? view.$helpers.getMomentFromStringTZ(data.to).add(-1, 'days').format("DD.MM.YYYY") : '-',
          },
          styleLabel: {
            display: 'flex', alignItems: 'center', justifyContent: 'center', background: '', height: 'calc(100% - 10px)'
          },
        }

      }];

      state.headerMap.period.stylesEntrySum = {color: 'black'}
      state.headerMap.period.sort = false;
      state.headerMap.period.componentStateBuilders = [(data, entry) => {
        return {
          componentType: 'labelc',
          state: {
            text: view.periodMap[data.period] ? (data.period == 1 ? (view.periodMap[data.period].label+' - '+view.$helpers.formatWeekDayArray(data.weekDays)) :   view.periodMap[data.period].label): '',
          },
          styleLabel: {
            display: 'flex', alignItems: 'center', justifyContent: 'center', background: '', height: 'calc(100% - 10px)'
          },
        }

      }];

      state.headerMap.amount.stylesEntrySum = {color: 'black'}
      state.headerMap.amount.sort = false;
      state.headerMap.amount.componentStateBuilders = [(data, entry) => {
        return {
          componentType: 'labelc',
          state: {
            text: (parseFloat(data.amount)/100.0).toFixed(2)+"€",
          },
          styleLabel: {
            display: 'flex', alignItems: 'center', justifyContent: 'center', background: '', height: 'calc(100% - 10px)'
          },
        }

      }];

      state.headerMap.crewlabor.stylesEntrySum = {color: 'black'}
      state.headerMap.crewlabor.sort = false;
      state.headerMap.crewlabor.componentStateBuilders = [(data, entry) => {
        return {
          componentType: 'labelc',
          state: {
            text: data.crewlabor ? this.$t('global.ui.yes') + ' - '+view.employeeLevelMap[data.employeeLevel].label : this.$t('global.ui.no'),
          },
          styleLabel: {
            display: 'flex', alignItems: 'center', justifyContent: 'center', background: '', height: 'calc(100% - 10px)'
          },
        }

      }];

      

      // Actions
      state.headerMap.actions.stylesEntry = {'justify-content': 'left'};
      state.headerMap.actions.componentStateBuilders = [
          (data, entry) => {
            return {
              componentType: 'buttonc',
              tooltip: () => {
                return this.$t('workBalance.averages.editEntry')
              },
              disabled: false,
              type: 'button icon-overlay square',
              icon: 'fa-edit',
              styleButton: {margin: '0 2px 0 2px'},
              customEvents: {
                click: (event) => {
                  view.OpenEditFixedCostPopup(data);
                }
              }
            }
          }
        ];

      let entries = Object.entries(state.headerMap);

      let mainColumnWidth = 15;
      let mainColumns = ["name", "period", "amount"];
      let nameColumns = ["crewlabor"];
      let nameColumnWidth =  15 ;

     
      let actionColumns = ["actions", "from", "to"];
      let actionColumnWidth = 5;
      for (let x in entries) {

        if (mainColumns.includes(entries[x][0])) {
          entries[x][1].width = mainColumnWidth + '%';
        } else if (nameColumns.includes(entries[x][0])) {
          entries[x][1].width = nameColumnWidth + '%';
        } else if (actionColumns.includes(entries[x][0])) {
          entries[x][1].width = actionColumnWidth + '%';
        }
        
        entries[x][1].key = entries[x][0];

      }
      state.headerStyles = {position: "sticky", top: 0, zIndex: 10, background: 'var(--sub-menu)'};
      state.heightSubRow = 'fit-content';
      state.rowStyles = {background: '#6d8d23'};
      state.rowStylesCollapsed = {background: 'var(--contrast-1)'};
      state.sumRowStyles = {background: 'var(--sub-menu)'}
      state.alwaysUnfold = false;
      return state;
    },
    currentMonthFrom(){
      
      let from = this.$helpers.getMomentFromValuesTZ(this.rosterFromTo.year, this.rosterFromTo.month, 1);
      return from;
    },
  },
  watch: {
    rosterFromTo(newVal, oldVal) {
      if (newVal != null && this.$store.state.jwt != undefined && this.$store.state.storeId != undefined) {
        console.log("CALLING REFRESH FROM ROSTERFROMTO")
        this.refresh(true);
      }
    },
    storeId(newVal, oldVal) {
      if (newVal != oldVal) {
        console.log("Changed storeId: " + newVal);
        console.log("CALLING REFRESH FROM STOREID")
        this.refresh(true);
        this.readyFlag = false;
      }
    }
  },
  // methods that implement data logic.
  methods: {
    initMonthly() {
      this.timeFrameStart = this.dateSelectionStart.clone().startOf('month');
    },
    refresh: function (force = false) {

      if (!this.loading) {
        let view = this;
        this.initMonthly();
        this.loading = true;
        return this.$helpers.GetUiDataMap(force)
        .then(response => {
          return view.$helpers.GetFixedCostMap(force)
        }).then(response => {
          
          view.loading = false;
        }).catch(function (error) {
          view.loading = false;
          console.log(error)
        });
      }
    },
    setDateSelection(date) {
      let fixedDate = this.$helpers.getMomentTZ().year(date.year()).month(date.month()).date(date.date()).startOf('day');
      this.dateSelectionStart = fixedDate;

      this.currentDate = fixedDate.date();
      this.currentMonth = fixedDate.month();
      this.currentYear = fixedDate.year();
      let rosterFromTo = this.$helpers.CalculateRosterFromTo(date);
      this.$store.commit('setRosterFromTo', {
                rosterFromTo: rosterFromTo
      });
      this.$forceUpdate();
    },
    PreviousDate() {
      let timeframe = 'month';
      

      this.timeFrameStart = this.timeFrameStart.add(-1, timeframe).clone();
      this.currentDate = this.timeFrameStart.date();
      this.currentMonth = this.timeFrameStart.month();
      this.currentYear = this.timeFrameStart.year();
      let rosterDate = this.timeFrameStart.clone().startOf('month');
      this.setDateSelection(rosterDate);

      this.$forceUpdate();
    },
    NextDate() {
      let timeframe = 'month';
      this.timeFrameStart = this.timeFrameStart.add(1, timeframe).clone();
      this.currentDate = this.timeFrameStart.date();
      this.currentMonth = this.timeFrameStart.month();
      this.currentYear = this.timeFrameStart.year();
      let rosterDate = this.timeFrameStart.clone().startOf('month');
      this.setDateSelection(rosterDate);
            
      this.$forceUpdate();
    },
    SetDateToCurrentDay() {
      this.timeFrameStart = this.$helpers.getMomentTZ().startOf('month');
      this.currentDate = this.timeFrameStart.date();
      this.currentMonth = this.timeFrameStart.month();
      this.currentYear = this.timeFrameStart.year();    
      this.setDateSelection(this.timeFrameStart);
    },
    toggleDatePicker($event) {
      let view = this;
      let date = this.$helpers.getMomentTZ().date(this.currentDate).month(this.currentMonth).year(this.currentYear);
      this.$helpers.OpenDatepickerPopup(
                { viewsEnabled: ['M'], date: date },
                {
                    OnDateSelect: (date) => { view.onDatePicked(date) },
                },
                { elRelative: $event ? $event.currentTarget : null });
    },
    onDatePicked(date) {
      this.timeFrameStart = date.clone();
      let rosterDate = this.timeFrameStart.clone().startOf('month');
      this.setDateSelection(rosterDate);
    },
    OpenMenuDetails($event, state) {
      let view = this;

      this.$helpers.OpenPopup({
        type: 'burgermenu',
        componentState: state,
        listStyle: true,
        noScroll: true,
        pointerDirection: 0,
        elRelative: $event.currentTarget,
        pointerOffset: -15,
      });
    },
    

    OpenNewFixedCostPopup() {
      let view = this;

      let dataEntries = [
        { label: this.$t('pages.employeeData.name'), key: 'name', hidden: false, type: 'text', value: ''},
        { label: this.$t('indicator.main.amount'), key: 'amount', hidden: false, type: 'numeric', value: 0},
        { label: this.$t('workBalance.bonus.recursIndefinitely'), key: 'noFrom', hidden: false, type: 'bool', value: true },
        {
          label: this.$t('workBalance.bonus.validFrom'),
          key: 'from',
          hidden: this.$helpers.CheckDatafillKeysForHiddenInverted('noFrom'),
          type: 'date',
          value: this.currentMonthFrom.clone().startOf('month'),
          flexGroup: false
        },
        { label: this.$t('workBalance.bonus.ongoingIndefinitely'), key: 'noTo', hidden: false, type: 'bool', value: true },
        {
          label: this.$t('pages.employeeContract.validUntil'),
          key: 'to',
          hidden: this.$helpers.CheckDatafillKeysForHiddenInverted('noTo'),
          type: 'date',
          value: this.currentMonthFrom.clone().startOf('month').add(1, 'month').add(-1, 'days'),
          flexGroup: false
        },
        {
          label: this.$t('indicator.crew.period'),
          key: 'period',
          hidden: false,
          type: 'dropdownsearch',
          value: 1,
          selectMultiple: false,
          flexGroup: false,
          dropdownSearchState: {
            toggled: false,
            displayedItems: [],
            input: '',
            items: Object.values(view.periodMap).map(p => {return {label: p.label, value: p.id}}),
            selectMultiple: false,
            selectedItems: [],
            selectedItem: {},
            onceSelected: function ($event, item, searchbar) {},
            styleLight: true,
            selectFirst: true,
          },
          styles: { width: '442px' }
        },      
        {label: this.$tc('store.settings.weekdays', 2),
          key: 'weekDays', hidden: false, flexGroup: false, type: 'togglelist', toggleEntries: [
              { label: this.$t('store.openingHours.weekDay1Short'), value: 1, selected: true },
              { label: this.$t('store.openingHours.weekDay2Short'), value: 2, selected: true },
              { label: this.$t('store.openingHours.weekDay3Short'), value: 3, selected: true },
              { label: this.$t('store.openingHours.weekDay4Short'), value: 4, selected: true },
              { label: this.$t('store.openingHours.weekDay5Short'), value: 5, selected: true },
              { label: this.$t('store.openingHours.weekDay6Short'), value: 6, selected: true },
              { label: this.$t('store.openingHours.weekDay7Short'), value: 7, selected: true},
          ], 
          computed: (datafill, lastVal, entryBeforeUpdate) => {
            let periodValue = datafill.entries.find(i => i.key == 'period').value;
            if (periodValue == 2) {
              entryBeforeUpdate.toggleEntries.forEach(e => e.selected = true);
              entryBeforeUpdate.hidden = true;
            } else {
              entryBeforeUpdate.hidden = false;
            }
            return entryBeforeUpdate;
          }
        },
        { label: this.$t('indicator.crew.countsAsCrewLabor'), key: 'crewlabor', hidden: false, type: 'bool', value: false },
        {
          label: this.$tc('store.structure.employeeLevel'),
          key: 'employeeLevel',
          hidden: this.$helpers.CheckDatafillKeysForHidden('crewlabor'),
          type: 'dropdownsearch',
          value: 1,
          flexGroup: false,
          dropdownSearchState: {
            toggled: false,
            displayedItems: [],
            input: '',
            selectFirst: true,
            items: Object.values(view.employeeLevelMap),
            selectMultiple: false,
            selectedItems: [],
            selectedItem: {},
            onceSelected: function ($event, item, searchbar) {},
            styleLight: true,
            
          },
          styles: { width: '442px' }
        }             
      ];


      this.$helpers.OpenPopup({
        elRelative: null,
        type: 'datafill',
        componentState: {
            entries: dataEntries,
            errorCheck: [
              (entries) => {
                if (view.$helpers.isEmpty(entries['name'])) {
                  return {
                    key: 'name',
                    type: 'error',
                    label: this.$t('pages.employeeData.name'),
                    text: this.$t('global.notifications.enterName')
                  }
                } else {
                  return null
                }
              },
              (entries) => {
                if (!entries['weekDays'] || entries['weekDays'].length < 1) {
                  return {
                    key: 'weekDays',
                    type: 'error',
                    label: this.$tc('store.settings.weekdays', 2),
                    text: this.$t('shift.template.selectWeekdayError')
                  }
                } else {
                  return null
                }
              },
              (entries) => {
                if (isNaN(parseFloat(entries['amount'])) || parseFloat(entries['amount']) == 0) {
                  return {
                    key: 'amount',
                    type: 'error',
                    label: this.$t('indicator.main.amount'),
                    text: this.$t('indicator.crew.pleaseEnterValidAmount')
                  }
                } else {
                  return null
                }
              },
          ],
          selectCallback: async (data) => {
            if(data.to != null){
              data.to = data.to.add(1, 'days');
            }
            view.createFixedCost(data);          
          },
        },
        header: this.$t('indicator.crew.newFixCosts'),
        remainAfterSelect: false,
        width: "600px",
        expanded: true,
        centered: true
      });
    },
      
    OpenEditFixedCostPopup(item) {
      let view = this;
      let periodItems = Object.values(view.periodMap).map(p => {return {label: p.label, value: p.id, selected: p.id == item.period}});
      let selectedPeriod = periodItems.find(p => p.selected);

      let employeeLevelItems = Object.values(view.employeeLevelMap).map(p => {return {label: p.label, value: p.value, selected: p.value == item.employeeLevel}});
      let selectedEmployeeLevel = employeeLevelItems.find(p => p.selected);

      let dataEntries = [
        { label: 'Id', key: 'id', hidden: true, type: 'text', value: item.id},
        { label: this.$t('pages.employeeData.name'), key: 'name', hidden: false, type: 'text', value: item.name},
        { label: this.$t('indicator.main.amount'), key: 'amount', hidden: false, type: 'numeric', value: item.amount/100.0},
        { label: this.$t('workBalance.bonus.recursIndefinitely'), key: 'noFrom', hidden: false, type: 'bool', value: item.from == null },
        {
          label: this.$t('workBalance.bonus.validFrom'),
          key: 'from',
          hidden: this.$helpers.CheckDatafillKeysForHiddenInverted('noFrom'),
          type: 'date',
          value: item.from != null ? this.$helpers.getMomentFromStringTZ(item.from): this.currentMonthFrom.clone().startOf('month'),
          flexGroup: false
        },
        { label: this.$t('workBalance.bonus.ongoingIndefinitely'), key: 'noTo', hidden: false, type: 'bool', value: item.to == null },
        {
          label: this.$t('pages.employeeContract.validUntil'),
          key: 'to',
          hidden: this.$helpers.CheckDatafillKeysForHiddenInverted('noTo'),
          type: 'date',
          value: item.to != null ? this.$helpers.getMomentFromStringTZ(item.to).add(-1, 'days') : this.currentMonthFrom.clone().startOf('month').add(1, 'month').add(-1, 'days'),
          flexGroup: false
        },
        {
          label: this.$t('indicator.crew.period'),
          key: 'period',
          hidden: false,
          type: 'dropdownsearch',
          value: item.period,
          selectMultiple: false,
          flexGroup: false,
          dropdownSearchState: {
            toggled: false,
            displayedItems: [],
            input: '',
            items: periodItems,
            selectMultiple: false,
            selectedItems: [selectedPeriod],
            selectedItem: selectedPeriod,
            onceSelected: function ($event, item, searchbar) {},
            styleLight: true,
            selectFirst: false,
          },
          styles: { width: '442px' }
        },      
        {label: this.$tc('store.settings.weekdays', 2),
          key: 'weekDays', hidden: selectedPeriod.value == 2, flexGroup: false, type: 'togglelist', toggleEntries: [
              { label: this.$t('store.openingHours.weekDay1Short'), value: 1, selected: item.weekDays.includes(1) },
              { label: this.$t('store.openingHours.weekDay2Short'), value: 2, selected: item.weekDays.includes(2) },
              { label: this.$t('store.openingHours.weekDay3Short'), value: 3, selected: item.weekDays.includes(3) },
              { label: this.$t('store.openingHours.weekDay4Short'), value: 4, selected: item.weekDays.includes(4) },
              { label: this.$t('store.openingHours.weekDay5Short'), value: 5, selected: item.weekDays.includes(5) },
              { label: this.$t('store.openingHours.weekDay6Short'), value: 6, selected: item.weekDays.includes(6) },
              { label: this.$t('store.openingHours.weekDay7Short'), value: 7, selected: item.weekDays.includes(7)},
              
          ], 
          computed: (datafill, lastVal, entryBeforeUpdate) => {
            let periodValue = datafill.entries.find(i => i.key == 'period').value;
            if (periodValue == 2) {
              entryBeforeUpdate.toggleEntries.forEach(e => e.selected = true);
              entryBeforeUpdate.hidden = true;
            } else {
              entryBeforeUpdate.hidden = false;
            }
            return entryBeforeUpdate;
          }
        },
        { label: this.$t('indicator.crew.countsAsCrewLabor'), key: 'crewlabor', hidden: false, type: 'bool', value: item.crewlabor },
        {
          label: this.$tc('store.structure.employeeLevel'),
          key: 'employeeLevel',
          hidden: this.$helpers.CheckDatafillKeysForHidden('crewlabor'),
          type: 'dropdownsearch',
          value: item.employeeLevel,
          flexGroup: false,
          dropdownSearchState: {
            toggled: false,
            displayedItems: [],
            input: '',
            selectFirst: false,
            items: employeeLevelItems,
            selectMultiple: false,
            selectedItems: [selectedEmployeeLevel],
            selectedItem: selectedEmployeeLevel,
            onceSelected: function ($event, item, searchbar) {},
            styleLight: true,
            
          },
          styles: { width: '442px' }
        }             
      ];


      this.$helpers.OpenPopup({
        elRelative: null,
        type: 'datafill',
        componentState: {
            entries: dataEntries,
            errorCheck: [
              (entries) => {
                if (view.$helpers.isEmpty(entries['name'])) {
                  return {
                    key: 'name',
                    type: 'error',
                    label: this.$t('pages.employeeData.name'),
                    text: this.$t('global.notifications.enterName')
                  }
                } else {
                  return null
                }
              },
              (entries) => {
                if (!entries['weekDays'] || entries['weekDays'].length < 1) {
                  return {
                    key: 'weekDays',
                    type: 'error',
                    label: this.$tc('store.settings.weekdays', 2),
                    text: this.$t('shift.template.selectWeekdayError')
                  }
                } else {
                  return null
                }
              },
              (entries) => {
                if (isNaN(parseFloat(entries['amount'])) || parseFloat(entries['amount']) == 0) {
                  return {
                    key: 'amount',
                    type: 'error',
                    label: this.$t('indicator.main.amount'),
                    text: this.$t('indicator.crew.pleaseEnterValidAmount')
                  }
                } else {
                  return null
                }
              },
          ],
          selectCallback: async (data) => {
            if(data.to != null){
              data.to = data.to.add(1, 'days');
            }
            view.editFixedCost(data);          
          },
          deleteCallback: async (data) => {
            view.deleteFixedCost(data);
          },
        },
        header: this.$t('indicator.crew.editFixCosts'),
        remainAfterSelect: false,
        width: "600px",
        expanded: true,
        centered: true
      });
      

    },

    createFixedCost(data) {
      let view = this;
      let url = '/api/sec/fixedcost';

      let params = {
          storeId: this.storeId
      };

      let payload = {
              name: data.name,
              amount: parseFloat(data.amount) * 100,
              from: data.noFrom ? null : data.from.format(),
              to: data.noTo ? null : data.to.format(),
              period: data.period,
              weekDays: data.weekDays,
              crewlabor: data.crewlabor,
              employeeLevel: data.employeeLevel ? data.employeeLevel : 1
            }

      this.axios({
          method: 'post',
          params: params,
          headers: {
            'AUTHORIZATION': "bearer " + this.$store.state.jwt
          },
          url: url,
          data: payload
      }).then(response => {
          view.$store.commit("setFixedCostMapEntry", response.data.data);

          view.$helpers.success(view.$t('store.events.creationSuccessful'), view.$t('indicator.crew.fixCostsCreated'))
        
      }).catch(function (error) {
        view.$helpers.error(view.$t('global.notifications.error'), view.$t('global.ui.createFailed'));
        console.log(error)
          
      })

    },
    editFixedCost(data) {
        let view = this;
        let url = '/api/sec/fixedcost';

        let params = {
          storeId: this.storeId
        };

        let payload = {
              id: data.id,
              name: data.name,
              amount: parseFloat(data.amount) * 100,
              from: data.noFrom ? null : data.from.format(),
              to: data.noTo ? null : data.to.format(),
              period: data.period,
              weekDays: data.weekDays,
              crewlabor: data.crewlabor,
              employeeLevel: data.employeeLevel ? data.employeeLevel : 1,
              updateFields: ['name', 'amount', 'from', 'to', 'period', 'weekDays', 'crewlabor', 'employeeLevel']
            }

        this.axios({
          method: 'put',
          params: params,
          headers: {
            'AUTHORIZATION': "bearer " + this.$store.state.jwt
          },
          url: url,
          data: payload
        }).then(response => {

          let entry = view.fixedCostMap[payload.id];
          entry.amount = payload.amount;
          entry.name = payload.name;
          entry.from = payload.from;
          entry.to = payload.to;
          entry.period = payload.period;
          entry.weekDays = payload.weekDays;
          entry.crewlabor = payload.crewlabor;
          entry.employeeLevel = payload.employeeLevel;
          

          view.$store.commit("setFixedCostMapEntry", entry);
          view.$helpers.success(view.$t('global.notifications.success'), view.$t('indicator.crew.entryEdited'));
          
        }).catch(function (error) {
          view.$helpers.error(view.$t('global.notifications.error'), view.$t('workBalance.averages.updatedDataError'));
          console.log(error)
          
        })

      },

      deleteFixedCost(data) {
        let view = this;
        let url = '/api/sec/fixedcost';

        let params = {
          id: data.id,
          storeId: this.storeId
        }


        this.axios({
          method: 'delete',
          params: params,
          headers: {
            'AUTHORIZATION': "bearer " + this.$store.state.jwt
          },
          url: url
        }).then(response => {
          view.$store.commit("deleteFixedCostMapEntry", {id: data.id});
          view.$helpers.success(view.$t('global.notifications.success'), view.$t('indicator.crew.entryDeleted'))
          
        }).catch(function (error) {
          view.$helpers.error(view.$t('global.notifications.error'), view.$t('global.ui.deleteFailed'));
          console.log(error)
          
      })
    },
    exportFixedCostPDF(){
        let view = this;
        let monthName = this.currentMonthFrom.format('MMMM YYYY');
       
        let headers = [this.$t('pages.employeeData.name'), this.$t('global.general.from'), this.$t('global.general.to'), this.$t('indicator.crew.period'), this.$t('indicator.crew.crewLabor'), this.$t('indicator.main.amount')];
        let body = [];

        let data = Object.values(this.fixedCostMap).sort((a, b) => {
          return a.name.localeCompare(b.name);
        });

        let monthTo = this.currentMonthFrom.clone().startOf('month').add(1, 'month');
        data.forEach(entry => {
            let from = entry.from ? view.$helpers.getMomentFromStringTZ(entry.from) : null;
            let to = entry.to ? view.$helpers.getMomentFromStringTZ(entry.to) : null;

            if((from == null || from < monthTo) && (to == null || to >this.currentMonthFrom)){
                let row = [];
                

                row.push(entry.name);
                row.push(from != null ? from.format("DD.MM.YYYY") : '-');
                row.push(to != null ? to.add(-1, 'days').format("DD.MM.YYYY") : '-');
                row.push(view.periodMap[entry.period] ? (entry.period == 1 ? (view.periodMap[entry.period].label+'\n'+view.$helpers.formatWeekDayArray(entry.weekDays)) :   view.periodMap[entry.period].label): '');
                row.push(entry.crewlabor ? this.$t('global.ui.no') + ' - '+view.employeeLevelMap[entry.employeeLevel].label : this.$t('global.ui.no'));
                row.push((parseFloat(entry.amount)/100.0).toFixed(2)+"€");
                body.push(row);
            }
        });

        let sumTotal = 0;
        data.forEach(entry => {
            let from = entry.from ? view.$helpers.getMomentFromStringTZ(entry.from) : null;
            let to = entry.to ? view.$helpers.getMomentFromStringTZ(entry.to) : null;

            if((from == null || from < monthTo) && (to == null || to >this.currentMonthFrom)){
                let row = [];
                let sum = 0;
                if(entry.period == 1){
                  let start = this.currentMonthFrom.clone().startOf('month');
                  while(start < monthTo){
                    if(entry.weekDays.includes(start.isoWeekday()) && (from == null || start >= from) && (to == null || start < to)){
                      sum += entry.amount;
                    }
                    start.add(1, 'days');
                  }
                } else {
                  let aFrom = from ? (from > this.currentMonth  ? from : this.currentMonthFrom) : this.currentMonthFrom;
                  let aTo = to ? (to < monthTo ? to : monthTo) : monthTo;
                  let ratio = aTo.diff(aFrom) / monthTo.diff(this.currentMonthFrom);
                  sum = entry.amount * ratio;
                }
                sumTotal += sum;

                row.push("Summe "+entry.name);
                row.push(monthName);
                row.push('');
                row.push('');
                row.push('');
                row.push((sum/100.0).toFixed(2)+"€");
                body.push(row);
            }
        });
        body.push(["Summe Gesamt", "", "", "", "", (sumTotal/100.0).toFixed(2)+"€"]);

                
        let filename = 'Fixkostenübersicht_' + monthName+'_'+this.yearDisplay+'.pdf';
        let repDoc = this.$helpers.tableReportDoc(
            headers,
            'Fixkostenübersicht ' + monthName,
            this.storeSettings.name,
            this.storeSettings.description,
            this.userFullname,
        9);
        let doc = repDoc.doc;
        let contentOffsetY = repDoc.contentOffsetY;
        doc.setFontSize(12);

        doc.setProperties({
            title: "Fixkostenübersicht",
        });

        doc.autoTable({
            startY: contentOffsetY,
            head: [headers],
            body: body,
            headStyles: {
              fillColor: [109,141,33],
              fontSize: 7,
            },
            bodyStyles: {
              fontSize: 7
            },
            columnStyles: {
            },
            horizontalPageBreak: headers.length > 15,
            horizontalPageBreakRepeat: 0,
        });

        view.$helpers.previewPdf(doc, filename);
            
    },

    
    
    hideModal(ref) {
      this.$refs[ref].hide()
    },
    showModal(ref) {
      this.$refs[ref].show()
    },
    
    
  
  }

}
</script>

<!-- Add "scoped" attriemployeete to limit CSS to this component only -->

<style scoped>
.tablecontainer {
  padding-left: 30px;
  padding-right: 30px;
  padding-bottom: 30px;
}

.has-header > .has-header > .scrollbar-container {
  height: calc(100% - var(--header-height) - var(--tab-menu-height)) !important;
  top: var(--header-height);
}


.data-table {
  top: 10px;
  position: relative;
}

::-webkit-scrollbar {
  display: none;
}
</style>
